import { combineReducers } from 'redux';

import print from './print';
import calculator, * as fromCalculator from './calculator/calculator';
import equivalencies, * as fromEquivalencies from './equivalencies';
import requirements, * as fromRequirements from './requirements';

export default combineReducers({
    print,
    calculator,
    equivalencies,
    requirements,
});

export const getInputValue = (state) => fromCalculator.getInputValue(state);
export const getDisableCalculateButton = (state) => fromCalculator.getDisableCalculateButton(state);
export const getError = (state) => fromCalculator.getError(state);
export const getErrorMessage = (state) => fromCalculator.getErrorMessage(state);
export const getShowCalculations = (state) => fromCalculator.getShowCalculations(state);
export const getEquivalencies = (state) => fromEquivalencies.getEquivalencies(state);
export const getRequirements = (state) => fromRequirements.getRequirements(state);


/** WEBPACK FOOTER **
 ** ./src/redux/modules/reducer.js
 **/